import type { ProjectIntakeSortByPropName } from '../inbox/types';

export const projectIntakeQueryKeys = {
  inbox: () => ['projectIntakeInbox'] as const,
  inboxList: (sortBy?: ProjectIntakeSortByPropName, desc?: boolean) => ['projectIntakeInbox', sortBy, desc] as const,
  detail: (intakeId?: number) =>
    intakeId === undefined ? (['projectIntakeDetail'] as const) : (['projectIntakeDetail', intakeId] as const)
};
